import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  TextField,
  MenuItem,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  IconButton,
  Card,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import Navbar1 from "../Navbar/Navbar1";
import BatchReport from "../Modal/Bathchine_Plant/Reports/BatchReport";
import ProductionReport from "../Modal/Bathchine_Plant/Reports/ProductionReport";
import ConsuptionReport from "../Modal/Bathchine_Plant/Reports/ConsuptionReport";
import ReceipeWiseConsuptionReport from "../Modal/Bathchine_Plant/Reports/ReceipeWiseConsuptionReport";
import CustomerReport from "../Modal/Bathchine_Plant/Reports/CustomerReport";
import RecipeWiseReport from "../Modal/Bathchine_Plant/Reports/RecipeWiseReport";
import GradeWiseReport from "../Modal/Bathchine_Plant/Reports/GradeWiseReport";
import TruckWiseData from "../Modal/Bathchine_Plant/Reports/TruckWiseData";
import BinwiseReport from "../Modal/Bathchine_Plant/Reports/BinwiseReport";
import ManualConsuptionReport from "../Modal/Bathchine_Plant/Reports/ManualConsuptionReport";
import ConsolidatedReport from "../Modal/Bathchine_Plant/Reports/ConsolidatedReport";
import SiteReporot from "../Modal/Bathchine_Plant/Reports/SiteReporot";
import axios from "axios";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const gradewiseData = {
  json_sts: "1",
  error_msg: "success",
  order_no: null,
  batch_no: null,
  cust_id: null,
  site_id: null,
  truck_id: null,
  driver: null,
  start: null,
  end: null,
  rec_id: null,
  rec_name: null,
  qty: null,
  plant_type: "M2.5",
  plant_sl: "269",
  qty_prod: null,
  tot_prod: null,
  run_hrs: null,
  prod_rate: null,
  date: null,
  tot_stwt: null,
  tot_atwt: null,
  recipe_name: null,
  recipe_code: null,
  lat: null,
  lon: null,
  upd_on: null,
  tot_count: null,
  cust_code: null,
  cust_name: null,
  order_name: null,
  site_name: null,
  data: [
    {
      recipe_name: "DLC",
      recipe_grade: "DLC",
      total_qty: "12.00",
      data: [
        {
          batch_no: "13062",
          batch_date: "2025-01-03",
          st: "11:38:37 AM",
          et: "11:47:12 AM",
          prod_qty: "12.00",
        },
      ],
    },
  ],
  mat_arr: [null],
  data_1: null,
  data_2: null,
  act_val_list: null,
  act_list: null,
  set_list: null,
  diff_list: null,
  data12: null,
  prod_data: null,
  cust_data: null,
  batch_data: null,
};

const binwiseData = {
  json_sts: "1",
  error_msg: "success",
  order_no: null,
  batch_no: null,
  cust_id: null,
  site_id: null,
  truck_id: null,
  driver: null,
  start: null,
  end: null,
  rec_id: null,
  rec_name: null,
  qty: null,
  plant_type: "M1.25",
  plant_sl: "245",
  qty_prod: null,
  tot_prod: null,
  run_hrs: null,
  prod_rate: null,
  date: null,
  tot_stwt: null,
  tot_atwt: null,
  recipe_name: null,
  recipe_code: null,
  lat: null,
  lon: null,
  upd_on: null,
  tot_count: null,
  cust_code: null,
  cust_name: "JAIN  ENGINEERS PVT LTD",
  order_name: null,
  site_name: null,
  data: [
    {
      cust_name: "JAIN  ENGINEERS PVT LTD",
      data: [
        {
          matName: "10MM",
          mat_atwt: 5809,
          mat_stwt: 5776,
          diff_kg: "-33.00",
          diff_percent: "-0.57",
        },
        {
          matName: "20MM",
          mat_atwt: 3951,
          mat_stwt: 3956,
          diff_kg: "5.00",
          diff_percent: "0.13",
        },
        {
          matName: "Admix2",
          mat_atwt: 64.86,
          mat_stwt: 64.86,
          diff_kg: "0.00",
          diff_percent: "0.00",
        },
        {
          matName: "C/SAND-1",
          mat_atwt: 4408,
          mat_stwt: 4374,
          diff_kg: "-34.00",
          diff_percent: "-0.78",
        },
        {
          matName: "C/SAND-2",
          mat_atwt: 4699,
          mat_stwt: 4672,
          diff_kg: "-27.00",
          diff_percent: "-0.58",
        },
        {
          matName: "Cem2",
          mat_atwt: 3946,
          mat_stwt: 3948,
          diff_kg: "2.00",
          diff_percent: "0.05",
        },
        {
          matName: "FLY",
          mat_atwt: 603,
          mat_stwt: 600,
          diff_kg: "-3.00",
          diff_percent: "-0.50",
        },
        {
          matName: "GGBS",
          mat_atwt: 1349,
          mat_stwt: 1350,
          diff_kg: "1.00",
          diff_percent: "0.07",
        },
        {
          matName: "Wtr1",
          mat_atwt: 2160,
          mat_stwt: 2134,
          diff_kg: "-26.00",
          diff_percent: "-1.22",
        },
      ],
    },
  ],
  mat_arr: [null],
  data_1: null,
  data_2: null,
  act_val_list: null,
  act_list: null,
  set_list: null,
  diff_list: null,
  data12: null,
  prod_data: null,
  cust_data: null,
  batch_data: null,
};

const consolidatedReportData = {
  json_sts: "1",
  error_msg: null,
  order_no: null,
  batch_no: null,
  cust_id: null,
  site_id: null,
  truck_id: null,
  driver: null,
  start: null,
  end: null,
  rec_id: null,
  rec_name: null,
  qty: null,
  plant_type: "M2.5",
  plant_sl: "251",
  qty_prod: null,
  tot_prod: null,
  run_hrs: null,
  prod_rate: null,
  date: null,
  tot_stwt: null,
  tot_atwt: null,
  recipe_name: null,
  recipe_code: null,
  lat: null,
  lon: null,
  upd_on: null,
  tot_count: null,
  cust_code: null,
  cust_name: null,
  order_name: null,
  site_name: null,
  data: [
    {
      b_no: "13055",
      st: "2025-01-01 10:00:26",
      et: "2025-01-01 10:07:01",
      trk: "MH42AQ-3849",
      dver: "98900410066",
      o_id: "M 15",
      c_id: "VH-HKATERI",
      site: "BHIGWAN",
      rec_id: "M 15",
      rec_name: "M 15",
      qty: "8.0000",
    },
    {
      b_no: "13056",
      st: "2025-01-01 12:48:34",
      et: "2025-01-01 12:57:33",
      trk: "MH42AQ-3849",
      dver: "98900410066",
      o_id: "M 15",
      c_id: "VH-HKATERI",
      site: "BHIGWAN",
      rec_id: "M 15",
      rec_name: "M 15",
      qty: "8.0000",
    },
    {
      b_no: "13057",
      st: "2025-01-02 10:00:45",
      et: "2025-01-02 10:13:00",
      trk: "MH42AQ-3849",
      dver: "98900410066",
      o_id: "M 15",
      c_id: "VH-HKATERI",
      site: "BHIGWAN",
      rec_id: "M 15",
      rec_name: "M 15",
      qty: "8.1000",
    },
    {
      b_no: "13058",
      st: "2025-01-02 12:27:40",
      et: "2025-01-02 12:29:27",
      trk: "MH42AQ-3849",
      dver: "98900410066",
      o_id: "M 20",
      c_id: "VH-HKATERI",
      site: "BHIGWAN",
      rec_id: "M 20",
      rec_name: "M 20",
      qty: "2.0000",
    },
    {
      b_no: "13059",
      st: "2025-01-02 16:13:33",
      et: "2025-01-02 16:16:43",
      trk: "MH42AQ-3849",
      dver: "98900410066",
      o_id: "M 15",
      c_id: "VH-HKATERI",
      site: "BHIGWAN",
      rec_id: "M 15",
      rec_name: "M 15",
      qty: "4.0000",
    },
    {
      b_no: "13060",
      st: "2025-01-03 09:26:29",
      et: "2025-01-03 09:32:30",
      trk: "MH42AQ-3849",
      dver: "98900410066",
      o_id: "M 15",
      c_id: "VH-HKATERI",
      site: "BHIGWAN",
      rec_id: "M 15",
      rec_name: "M 15",
      qty: "7.5200",
    },
    {
      b_no: "13061",
      st: "2025-01-03 09:41:45",
      et: "2025-01-03 09:48:31",
      trk: "MH42AQ-3849",
      dver: "98900410066",
      o_id: "M 15",
      c_id: "VH-HKATERI",
      site: "BHIGWAN",
      rec_id: "M 15",
      rec_name: "M 15",
      qty: "7.5200",
    },
    {
      b_no: "13062",
      st: "2025-01-03 11:38:37",
      et: "2025-01-03 11:47:12",
      trk: "MH42BF-1527",
      dver: "709530615",
      o_id: "DLC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "DLC",
      rec_name: "DLC",
      qty: "12.0000",
    },
    {
      b_no: "13063",
      st: "2025-01-03 15:34:36",
      et: "2025-01-03 15:40:24",
      trk: "MH42AQ-3849",
      dver: "98900410066",
      o_id: "M 15",
      c_id: "VH-HKATERI",
      site: "BHIGWAN",
      rec_id: "M 15",
      rec_name: "M 15",
      qty: "8.0000",
    },
    {
      b_no: "13064",
      st: "2025-01-03 21:00:43",
      et: "2025-01-03 21:12:26",
      trk: "MH42AQ 0274",
      dver: "MAHESH",
      o_id: "PQC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "PQC",
      rec_name: "PQC",
      qty: "2.0000",
    },
    {
      b_no: "13065",
      st: "2025-01-03 21:14:06",
      et: "2025-01-03 21:25:36",
      trk: "MH42AQ 0274",
      dver: "MAHESH",
      o_id: "PQC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "PQC",
      rec_name: "PQC",
      qty: "16.0000",
    },
    {
      b_no: "13066",
      st: "2025-01-03 21:28:00",
      et: "2025-01-03 21:41:00",
      trk: "MH42AQ 0274",
      dver: "MAHESH",
      o_id: "PQC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "PQC",
      rec_name: "PQC",
      qty: "18.0000",
    },
    {
      b_no: "13067",
      st: "2025-01-03 21:41:59",
      et: "2025-01-03 21:55:48",
      trk: "MH42AQ 0274",
      dver: "MAHESH",
      o_id: "PQC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "PQC",
      rec_name: "PQC",
      qty: "18.0000",
    },
    {
      b_no: "13068",
      st: "2025-01-03 21:57:39",
      et: "2025-01-03 22:10:37",
      trk: "MH42AQ 0274",
      dver: "MAHESH",
      o_id: "PQC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "PQC",
      rec_name: "PQC",
      qty: "18.0000",
    },
    {
      b_no: "13069",
      st: "2025-01-03 22:18:25",
      et: "2025-01-03 22:30:09",
      trk: "MH42AQ 0274",
      dver: "MAHESH",
      o_id: "PQC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "PQC",
      rec_name: "PQC",
      qty: "18.0000",
    },
    {
      b_no: "13070",
      st: "2025-01-03 22:42:19",
      et: "2025-01-03 22:54:03",
      trk: "MH42AQ 0274",
      dver: "MAHESH",
      o_id: "PQC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "PQC",
      rec_name: "PQC",
      qty: "18.0000",
    },
    {
      b_no: "13071",
      st: "2025-01-03 23:01:17",
      et: "2025-01-03 23:13:25",
      trk: "MH42AQ 0274",
      dver: "MAHESH",
      o_id: "PQC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "PQC",
      rec_name: "PQC",
      qty: "18.0000",
    },
    {
      b_no: "13072",
      st: "2025-01-03 23:15:05",
      et: "2025-01-03 23:28:23",
      trk: "MH42AQ 0274",
      dver: "MAHESH",
      o_id: "PQC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "PQC",
      rec_name: "PQC",
      qty: "18.0000",
    },
    {
      b_no: "13073",
      st: "2025-01-03 23:50:54",
      et: "2025-01-04 00:02:43",
      trk: "MH42AQ 0274",
      dver: "MAHESH",
      o_id: "PQC",
      c_id: "VH-KHATRI",
      site: "BHIGWAN TO BARAMATI",
      rec_id: "PQC",
      rec_name: "PQC",
      qty: "17.0400",
    },
  ],
  mat_arr: [null],
  data_1: null,
  data_2: null,
  act_val_list: null,
  act_list: null,
  set_list: null,
  diff_list: null,
  data12: null,
  prod_data: null,
  cust_data: null,
  batch_data: null,
};

const siteData = {
  json_sts: "1",
  error_msg: "success",
  order_no: null,
  batch_no: null,
  cust_id: null,
  site_id: null,
  truck_id: null,
  driver: null,
  start: null,
  end: null,
  rec_id: null,
  rec_name: null,
  qty: null,
  plant_type: "M1.25",
  plant_sl: "245",
  qty_prod: null,
  tot_prod: null,
  run_hrs: null,
  prod_rate: null,
  date: null,
  tot_stwt: null,
  tot_atwt: null,
  recipe_name: null,
  recipe_code: null,
  lat: null,
  lon: null,
  upd_on: null,
  tot_count: null,
  cust_code: null,
  cust_name: null,
  order_name: null,
  site_name: null,
  data: [
    {
      cust_name: "AAKAR ASSOCITION",
      site: "ANDHERI",
      prod_qty: "13.56",
      data: [
        {
          batch_no: "2104",
          batch_date: "2025-01-03",
          st: "00:38:57 AM",
          et: "00:48:55 AM",
          recipe_id: "M-40 AKASH GGBS",
          prod_qty: "6.78",
        },
        {
          batch_no: "2103",
          batch_date: "2025-01-02",
          st: "23:52:41 PM",
          et: "00:03:12 AM",
          recipe_id: "M-40 AKASH GGBS",
          prod_qty: "6.78",
        },
      ],
    },
  ],
  mat_arr: [null],
  data_1: null,
  data_2: null,
  act_val_list: null,
  act_list: null,
  set_list: null,
  diff_list: null,
  data12: null,
  prod_data: null,
  cust_data: null,
  batch_data: null,
};

export default function Report() {
  const machineMacInfo =
    JSON.parse(localStorage.getItem("machineMacInfo")) || [];
  const [plantType, setPlantType] = useState(null);
  const [plantId, setPlantId] = useState(null);
  const [mac_id, setMac_id] = useState(null);
  const [selcttoDate, setSelectToDate] = useState(null);
  const [selectFromDate, setSelectFromDate] = useState(null);
  const [selectMenu, setSelectMenu] = useState(0);
  const [batchReportData, setBatchReportData] = useState(null);
  const [productionReportData, setProductionReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [consuptionReport, setConsuptionReport] = useState(null);
  const [recipewiseConsuptionReport, setRecipeWiseConsuptionReport] =
    useState(null);
  const [customerList, setCustomerList] = useState(null);
  const [selectCustomer, setSelectCustomer] = useState(null);
  const [customerId, setCustomerId] = useState(null);

  const [recipeList, setRecipeList] = useState(null);
  const [selectrecipe, setSelectRecipe] = useState(null);
  const [recipeId, setRecipeIde] = useState(null);

  const [customerReportData, setCustomerReportData] = useState(null);

  const [recipewiseData, setRecipewiseData] = useState(null);
  const [manualConsuptionData, setManualConsuptionData] = useState(null);
  const [sendPlantType, setSenPlantType] = useState(null);
  const [sendplantSINo, setSendPlantSINo] = useState(null);

  const customerMaster = async () => {
    try {
      const payload = {
        rpt_type: "customer list",
        mac_id: mac_id,
        prod_id: plantId,
        date_filter: "Yes",
        start: dayjs(selectFromDate).format("YYYY-MM-DD"),
        end: dayjs(selcttoDate).format("YYYY-MM-DD"),
      };

      const token = localStorage.getItem("token");

      const response = await axios.post(
        "https://iot-api.elantristechnologies.com/api/BatchingPlant/Get_MastersList",
        payload, // ✅ payload goes here
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ headers here
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Customer Master Data:", response.data);

      setCustomerList([
        { list: "All", id: "all" },
        ...response.data.data.map((item) => ({
          list: item.a,
          id: item.a,
        })),
      ]);

      setCustomerId("All");
      setSelectCustomer("All");
    } catch (error) {
      console.error("Error fetching customer master:", error);
    }
  };

  const recipeMaster = async () => {
    try {
      const payload = {
        rpt_type: "recipe list",
        mac_id: mac_id,
        prod_id: plantId,
        date_filter: "Yes",
        start: dayjs(selectFromDate).format("YYYY-MM-DD"),
        end: dayjs(selcttoDate).format("YYYY-MM-DD"),
      };

      const token = localStorage.getItem("token");

      const response = await axios.post(
        "https://iot-api.elantristechnologies.com/api/BatchingPlant/Get_MastersList",
        payload, // ✅ payload goes here
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ headers here
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Customer Master Data:", response.data);

      setRecipeList([
        { list: "All", id: "all" }, // 👈 default option
        ...response.data.data.map((item) => ({
          list: item.b,
          id: item.a,
        })),
      ]);

      setRecipeIde("All");
      setSelectRecipe("All");
    } catch (error) {
      console.error("Error fetching customer master:", error);
    }
  };

  // Report -1
  const bactchReport = () => {
    setLoading(true);

    const payload = {
      rpt_type: "Batch Report",
      mac_id: mac_id,
      prod_id: plantId,
      start: dayjs(selectFromDate).format("YYYY-MM-DD"),
      end: dayjs(selcttoDate).format("YYYY-MM-DD"),
    };

    const token = localStorage.getItem("token"); // 👈 actual token

    axios
      .post(
          
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      )

      .then((res) => {
        if (res.data.status == "1") {
          setBatchReportData(res.data.data);
          setSendPlantSINo(res.data.p_sl);
          setSenPlantType(res.data.p_t);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Report -2
  const productionReport = () => {
    setLoading(true);

    const payload = {
      rpt_type: "Production Report",
      mac_id: mac_id,
      prod_id: plantId,
      start: dayjs(selectFromDate).format("YYYY-MM-DD"),
      end: dayjs(selcttoDate).format("YYYY-MM-DD"),
    };
    const token = localStorage.getItem("token"); // 👈 actual token

    axios
      .post(
        "https://iot-api.elantristechnologies.com/api/BatchingPlant/Report_ProductionData",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      )

      .then((res) => {
        if (res.data.status == "1") {
          setProductionReportData(res.data);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Report -3
  const consuptionReportApi = () => {
    setLoading(true);

    const payload = {
      rpt_type: "customer-wise report",
      mac_id: mac_id,
      prod_id: plantId,
      cust_id: customerId,
      start: dayjs(selectFromDate).format("YYYY-MM-DD"),
      end: dayjs(selcttoDate).format("YYYY-MM-DD"),
    };
    const token = localStorage.getItem("token"); // 👈 actual token

    axios
      .post(
        "https://iot-api.elantristechnologies.com/api/BatchingPlant/Report_CustomerWiseConsData",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      )

      .then((res) => {
        if (res.data.status == "1") {
          setConsuptionReport(res.data);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Report -4
  const recipewiseconsReportApi = () => {
    setLoading(true);

    const payload = {
      rpt_type: "string",
      mac_id: mac_id,
      prod_id: plantId,
      recipe_id: recipeId,
      start: dayjs(selectFromDate).format("YYYY-MM-DD"),
      end: dayjs(selcttoDate).format("YYYY-MM-DD"),
    };
    const token = localStorage.getItem("token"); // 👈 actual token

    axios
      .post(
        "https://iot-api.elantristechnologies.com/api/BatchingPlant/Report_RecipeWiseConsData",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      )

      .then((res) => {
        if (res.data.status == "1") {
          setRecipeWiseConsuptionReport(res.data);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Report -5
  const CustomerReportAPi = () => {
    setLoading(true);

    const payload = {
      rpt_type: "Production Report",
      mac_id: mac_id,
      prod_id: plantId,
      cust_id: recipeId,
      start: dayjs(selectFromDate).format("YYYY-MM-DD"),
      end: dayjs(selcttoDate).format("YYYY-MM-DD"),
    };

    // const payload = {
    //   rpt_type: "Production Report",
    //   mac_id: "MI0001",
    //   prod_id: "PI001",
    //   cust_id: "All",
    //   start: "2025-10-14",
    //   end: "2025-11-14",
    // };

    const token = localStorage.getItem("token"); // 👈 actual token

    axios
      .post(
        "https://iot-api.elantristechnologies.com/api/BatchingPlant/Report_RecipeWiseProductionData",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      )

      .then((res) => {
        if (res.data.status == "1") {
          setCustomerReportData(res.data);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Report -6

  const recipewiseReportAPi = () => {
    setLoading(true);

    const payload = {
      rpt_type: "Recipe Production Report ",
      mac_id: mac_id,
      prod_id: plantId,
      recipe_id: recipeId,
      start: dayjs(selectFromDate).format("YYYY-MM-DD"),
      end: dayjs(selcttoDate).format("YYYY-MM-DD"),
    };

    // const payload = {
    //   rpt_type: "Production Report",
    //   mac_id: "MI0001",
    //   prod_id: "PI001",
    //   cust_id: "All",
    //   start: "2025-10-14",
    //   end: "2025-11-14",
    // };

    const token = localStorage.getItem("token"); // 👈 actual token

    axios
      .post(
        "https://iot-api.elantristechnologies.com/api/BatchingPlant/Report_RecipeWiseProductionData",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      )

      .then((res) => {
        if (res.data.status == "1") {
          setRecipewiseData(res.data);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Report 7

  const manualConsuptionReportAPi = () => {
    setLoading(true);

    const payload = {
      rpt_type: "Manual Cons",
      mac_id: mac_id,
      prod_id: plantId,

      start: dayjs(selectFromDate).format("YYYY-MM-DD"),
      end: dayjs(selcttoDate).format("YYYY-MM-DD"),
    };

    const token = localStorage.getItem("token"); // 👈 actual token

    axios
      .post(
        "https://iot-api.elantristechnologies.com/api/BatchingPlant/Report_ManualConsumptionData",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      )

      .then((res) => {
        if (res.data.status == "1") {
          setManualConsuptionData(res.data);
        } else {
          alert(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const menuItems = [
    "Batch Report Datewise",
    "Batchwise Report",
    "Production Report",
    "Consumption Report",
    "Recipewise Cons. Report",
    "Customer Report",
    "Recipewise Report",
    // "Gradewise Report",
    // "Truckwise Report",
    // "Binwise Cons. Report",
    "Manual Consumption Report",
    // "Consolidated Report",
    // "Site Report",
  ];

  useEffect(() => {
    if (machineMacInfo.length > 0) {
      const first = machineMacInfo[0];

      setPlantType(first.mac_type);
      setPlantId(first.prod_id);
      setMac_id(first.mac_id);
    }
  }, []);

  useEffect(() => {
    if (selectMenu === 3 || selectMenu === 5) {
      if (selectFromDate && selcttoDate) {
        customerMaster();
      }
    } else if (selectMenu === 4 || selectMenu === 6) {
      if (selectFromDate && selcttoDate) {
        recipeMaster();
      }
    }
  }, [selectMenu, mac_id, plantId, selectFromDate, selcttoDate]);

  return (
    <Navbar1>
      <Grid container sx={{ pl: 2, pr: 2 }} spacing={1}>
        {/* Right Section */}
        <Grid size={{ lg: 2.5, xs: 12, md: 12, sm: 12 }}>
          {/* LEFT SIDEBAR */}
          <Grid sx={{ borderRadius: 0, bgcolor: "#fff" }}>
            <List>
              {menuItems.map((item, index) => (
                <ListItemButton
                  key={item}
                  sx={{
                    borderBottom: "1px solid #eee",
                    bgcolor: index === selectMenu ? "#1976d2" : "transparent",
                    color: index === selectMenu ? "#fff" : "#000",
                    "&:hover": {
                      bgcolor: index === selectMenu ? "#1565c0" : "#f0f0f0",
                    },
                  }}
                  onClick={() => {
                    setSelectMenu(index);
                  }}
                >
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "12px",
                    }}
                  />
                </ListItemButton>
              ))}
            </List>
          </Grid>
        </Grid>
        <Grid size={{ lg: 9.5, xs: 12, md: 12, sm: 12 }}>
          <Grid sx={{ bgcolor: "#fff", padding: 2, borderRadius: 0 }}>
            <Grid container spacing={3}>
              {/* Batch Select */}
              <Grid size={{ lg: 2.5, xs: 12, md: 12, sm: 12 }}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#2e2e2e",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Plant Type
                </Typography>
                <TextField
                  select
                  fullWidth
                  size='small'
                  value={plantId}
                  onChange={(e) => {
                    const selectedId = e.target.value;

                    const selectedItem = machineMacInfo.find(
                      (item) => item.mac_id === selectedId,
                    );

                    if (selectedItem) {
                      setPlantType(selectedItem.mac_type);
                      setPlantId(selectedItem.prod_id);
                      setMac_id(selectedItem.mac_id);
                    }
                  }}
                  InputProps={{
                    sx: {
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "14px",
                    },
                  }}
                >
                  {machineMacInfo.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item.prod_id} // always give one unique value
                      sx={{
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "14px",
                      }}
                    >
                      {item.mac_type}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* From Date */}
              <Grid size={{ lg: 2.5, xs: 12, md: 12, sm: 12 }}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#2e2e2e",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Slect From Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    views={["day", "month", "year"]}
                    format='DD-MM-YYYY'
                    value={selectFromDate}
                    // minDate={dayjs("2025-10-18")}
                    maxDate={dayjs()}
                    onChange={(newValue) => {
                      setSelectFromDate(newValue);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",

                        InputLabelProps: {
                          shrink: true,
                          sx: {
                            fontFamily: "Poppins, sans-serif !important",
                            fontSize: "13px !important",
                          },
                        },

                        InputProps: {
                          sx: {
                            fontFamily: "Poppins, sans-serif !important",
                            fontSize: "14px !important",
                          },
                        },

                        sx: {
                          "& .MuiInputBase-input": {
                            fontFamily: "Poppins, sans-serif !important",
                            fontSize: "14px !important",
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins, sans-serif !important",
                            fontSize: "13px !important",
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              {/* To Date */}
              <Grid size={{ lg: 2.5, xs: 12, md: 12, sm: 12 }}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#2e2e2e",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Select To Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    minDate={selectFromDate}
                    views={["day", "month", "year"]}
                    format='DD-MM-YYYY'
                    //  minDate={dayjs("2025-10-18")}
                    maxDate={dayjs()}
                    value={selcttoDate}
                    onChange={(newValue) => {
                      setSelectToDate(newValue);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",

                        InputLabelProps: {
                          shrink: true,
                          sx: {
                            fontFamily: "Poppins, sans-serif !important",
                            fontSize: "13px !important",
                          },
                        },

                        InputProps: {
                          sx: {
                            fontFamily: "Poppins, sans-serif !important",
                            fontSize: "14px !important",
                          },
                        },

                        sx: {
                          "& .MuiInputBase-input": {
                            fontFamily: "Poppins, sans-serif !important",
                            fontSize: "14px !important",
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins, sans-serif !important",
                            fontSize: "13px !important",
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              {/* Radio Buttons */}
              {/* <Grid size={{ lg: 2, xs: 12, md: 12, sm: 12 }}>
                <RadioGroup row defaultValue='basic'>
                  <FormControlLabel
                    value='basic'
                    control={<Radio />}
                    label='Basic'
                  />
                  <FormControlLabel
                    value='detailed'
                    control={<Radio />}
                    label='Detailed'
                  />
                </RadioGroup>
              </Grid> */}

              {/* Get Data Button */}
              <Grid
                size={{ lg: 4.5, xs: 12, md: 12, sm: 12 }}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  gap: 2,
                }}
              >
                {selectMenu == 3 || selectMenu == 5 ? (
                  <Grid sx={{ width: "50%" }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#2e2e2e",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      Customer ID
                    </Typography>
                    <TextField
                      select
                      fullWidth
                      size='small'
                      value={selectCustomer}
                      onChange={(e) => {
                        const selectedValue = e.target.value;

                        const selectedItem = customerList.find(
                          (item) => item.list === selectedValue,
                        );

                        console.log(selectedItem);

                        setSelectCustomer(selectedItem.list);
                        setCustomerId(selectedItem.id);
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "14px",
                        },
                      }}
                    >
                      {customerList?.map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item.list}
                          sx={{
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                          }}
                        >
                          {item.list}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                ) : selectMenu == 4 || selectMenu == 6 ? (
                  <Grid sx={{ width: "50%" }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#2e2e2e",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      Recipe ID
                    </Typography>
                    <TextField
                      select
                      fullWidth
                      size='small'
                      value={selectrecipe}
                      onChange={(e) => {
                        const selectlist = e.target.value;

                        const selectedItem = recipeList.find(
                          (item) => item.list === selectlist,
                        );

                        if (selectedItem) {
                          setSelectRecipe(selectedItem.list);
                          setRecipeIde(selectedItem.id);
                        }
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "14px",
                        },
                      }}
                    >
                      {recipeList &&
                        recipeList.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.list} // always give one unique value
                            sx={{
                              fontFamily: "Poppins, sans-serif",
                              fontSize: "14px",
                            }}
                          >
                            {item.list}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                ) : (
                  ""
                )}

                <Grid
                  sx={{
                    width: "50%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant='contained'
                    fullWidth
                    sx={{
                      height: 30,
                      width: 100,
                      bgcolor: "#144FEE",
                      textTransform: "none",
                      fontFamily: "Poppins",
                      fontWeight: 600,
                      boxShadow: "none",
                      mt: 2,
                    }}
                    // if (!customerId) {
                    //     alert("Select Customer Id");
                    //   } else if (!selectFromDate) {
                    //     alert("Select Start Date");
                    //   } else if (!selectFromDate) {
                    //     alert("Select End Date");
                    //   }
                    onClick={() => {
                      if (selectMenu == 0 || selectMenu == 1) {
                        bactchReport();
                      } else if (selectMenu == 2) {
                        productionReport();
                      } else if (selectMenu == 3) {
                        consuptionReportApi();
                      } else if (selectMenu == 4) {
                        recipewiseconsReportApi();
                      } else if (selectMenu == 5) {
                        CustomerReportAPi();
                      } else if (selectMenu == 6) {
                        recipewiseReportAPi();
                      } else if (selectMenu == 7) {
                        manualConsuptionReportAPi();
                      }
                    }}
                  >
                    Get Data
                  </Button>
                </Grid>
              </Grid>

              {/* Icons */}
              {/* <Grid size={{ lg: 1.5, xs: 12, md: 12, sm: 12 }}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <IconButton color='primary'>
                    <PictureAsPdfIcon />
                  </IconButton>
                  <IconButton color='success'>
                    <GridOnIcon />
                  </IconButton>
                </Box>
              </Grid> */}
            </Grid>
          </Grid>

          {selectMenu === 0 || selectMenu === 1 ? (
            batchReportData ? (
              <BatchReport
                batchHeaderData={batchReportData}
                reportType='basic'
                sendPlantType={sendPlantType}
                sendplantSINo={sendplantSINo}
              />
            ) : null
          ) : selectMenu === 2 ? (
            <ProductionReport
              reportData={productionReportData}
              from={selectFromDate}
              to={selcttoDate}
            />
          ) : selectMenu === 3 ? (
            <ConsuptionReport
              reportData={consuptionReport}
              from={selectFromDate}
              to={selcttoDate}
            />
          ) : selectMenu === 4 ? (
            <ReceipeWiseConsuptionReport
              reportData={recipewiseConsuptionReport}
              from={selectFromDate}
              to={selcttoDate}
            />
          ) : selectMenu === 5 ? (
            <CustomerReport
              reportData={customerReportData}
              from={selectFromDate}
              to={selcttoDate}
            />
          ) : selectMenu === 6 ? (
            <RecipeWiseReport
              reportData={recipewiseData}
              from={selectFromDate}
              to={selcttoDate}
            />
          ) : selectMenu === 7 ? (
            <ManualConsuptionReport
              reportData={manualConsuptionData}
              from={selectFromDate}
              to={selcttoDate}
            />
          ) : // <GradeWiseReport
          //   reportData={gradewiseData}
          //   from='1-1-2025'
          //   to='3-4-5'
          // />
          selectMenu === 8 ? (
            <TruckWiseData
              reportData={gradewiseData}
              from='1-1-2025'
              to='3-4-5'
            />
          ) : selectMenu === 9 ? (
            <BinwiseReport
              reportData={binwiseData}
              from='1-1-2025'
              to='3-4-5'
            />
          ) : selectMenu === 10 ? (
            <ManualConsuptionReport
              reportData={manualConsuptionData}
              from='1-1-2025'
              to='3-4-5'
            />
          ) : selectMenu === 11 ? (
            <ConsolidatedReport
              reportData={consolidatedReportData}
              from='1-1-2025'
              to='3-4-5'
            />
          ) : selectMenu === 12 ? (
            <SiteReporot reportData={siteData} from='1-1-2025' to='3-4-5' />
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </Navbar1>
  );
}
